module.exports = Em.Component.extend({
    classNames: ['approve-bookkeeping-list']
})
